import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import Clients from './index.js'

if (!store?.state?.['Clients']) {
	store.registerModule('Clients', Clients)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('Clients')
